import classNames from 'classnames';
import { LocationDescriptorObject } from 'history';
import React, { CSSProperties, ElementType } from 'react';
import { useRouteLink } from '../helpers/hooks';
import Icon, { IconType } from './Icon';
import ModalLink from './Modal/ModalLink';

type TableRowProps = {
  tableData: {
    data: {
      title: string;
      info: {
        text: string;
        color?: string;
      };
      prefixIcon?: {
        iconName: string;
        iconType: IconType;
        iconClassName: string;
        iconSize?: number;
      };
    }[];
    link?: string;
  };
  as?: ElementType;
  containerStyle?: CSSProperties;
  containerClassName?: string;
  to?: LocationDescriptorObject;
};

const TableRow = ({
  as = 'div',
  tableData,
  containerStyle = {},
  containerClassName = '',
  ...restProps
}: TableRowProps) => {
  const { link, data } = tableData;
  const linkTo = useRouteLink();
  let Container: ElementType;
  let containerProps: { to: LocationDescriptorObject } | null = null;
  if (link) {
    Container = ModalLink;
    containerProps = {
      to: linkTo(link)
    };
  } else {
    Container = as;
  }
  return (
    <Container
      style={containerStyle}
      className={classNames(
        containerClassName,
        'flex flex-shrink-0 border py-2 px-4 rounded-t rounded-br rounded-bl-sm mb-2'
      )}
      {...restProps}
      {...containerProps}
    >
      {data.map(({ title, info, prefixIcon }) => (
        <div className="flex flex-col flex-1 items-center first:items-start last:items-end">
          <span className="font-body text-xs text-gray-600">{title}</span>
          <span
            className="inline-flex font-body text-gray-900 items-center text-sm"
            style={{ color: info.color }}
          >
            {prefixIcon && (
              <Icon
                {...(() => {
                  const {
                    iconType,
                    iconName,
                    iconSize,
                    iconClassName = '',
                    ...rest
                  } = prefixIcon;
                  return {
                    name: iconName,
                    type: iconType,
                    size: iconSize,
                    className: iconClassName,
                    ...rest
                  };
                })()}
              />
            )}
            <span className="whitespace-no-wrap">{info.text}</span>
          </span>
        </div>
      ))}
    </Container>
  );
};

export default TableRow;
